/* istanbul ignore file */
export * from "./types";
export { default as WindowMessageTransport } from "./WindowMessageTransport";
//# sourceMappingURL=index.js.map